import React,{ Component } from 'react';
import PropTypes from 'prop-types';

import {
  Row,
  Col,
  Input,
  FormGroup,
  Label, FormText
} from 'reactstrap';

import Form from '../../../shared/components/Form';
import TextInput from '../../../shared/components/TextInput';
import MoneyInput from '../../../shared/components/MoneyInput';
import Button from '../../../shared/components/Button';

import find from 'lodash/find';

import {
  formatPaymentMethod, uploadFile
} from '../../../shared/utils';
import moment from "moment-timezone";
import {DEFAULT_TIMEZONE} from "../../../config";
import {loadAccountIOList} from "../../../shared/redux/accounting/actions";

class AccountNewIO extends Component {
  constructor(props){
    super(props);

    this.state = {
      isLoaded:false,
      isSubmitting: false,
      error:null,
      validationMessages:{},
      documents: [],
      isInvoiceSelected: false,
      amount: '',
      note: '',
      paymentMethodId:''
    };
  }
  componentWillMount() {
    const {io} = this.props
    if (io) {
      this.setState({documents: io.documents || [],
        amount: io.amount,
        note: io.note,
        paymentMethodId: io.paymentMethodId,
        isInvoiceSelected: false,
        isCreate: false
      });
    }
  }

  componentWillUpdate(newProps, newState) {
    if (!newProps.isCreate && newProps.note && !this.props.note){
      const {io} = newProps
      this.setState({documents: io.documents || [],
        amount: io.amount,
        note: io.note,
        paymentMethodId: io.paymentMethodId,
        isInvoiceSelected: this.props.paymentMethods.filter((p) => p.id === io.paymentMethodId).map((p) => p.kind).indexOf('invoice') !== -1,
        isCreate: false
      });
    }
  }

  componentDidMount(){
    const {
      loadPaymentMethodsForAgency,
      loadIOSForAgency,
      accountId
    } = this.props;

    Promise
      .all([ loadPaymentMethodsForAgency(accountId), loadIOSForAgency(accountId) ])
      .then(() => this.setState({isLoaded:true}))
      .catch((err) => this.setState({error:err}));
  }

  handleSubmit(data){
    this.setState({isSubmitting: true})
    const {documents, isInvoiceSelected} = this.state
    const {
      isCreate,
      accountId,
      io,
      createIO,
        updateIO,
      updateIODocuments
    } = this.props;


    const validationMessages = {};
    console.log(data)
    if(isCreate && (!data.amount || parseFloat(data.amount) === 0)){
      validationMessages['amount'] = 'Amount is required';
    }

    if(!data.note || data.note.length === 0){
      validationMessages['note'] = 'Notes is required';
    }

    if(Object.keys(validationMessages).length > 0){
      this.setState({validationMessages:validationMessages, isSubmitting: false});
      return;
    }

    if (!isCreate) {
      updateIO(io.id, {
        // ...(data.note !== io.note && {note: data.note}),
        note: data.note,
        documents: documents.map(d => ({url: d.url, fileName: d.fileName}))})
          .then(() => this.props.loadIOSForAgency(this.props.accountId))
          .then(() => {
            this.handleSuccess()
            this.setState({isSubmitting: false})
          })
          .catch((err) => {
            this.handleError(err)
            this.setState({isSubmitting: false})
          })

      return
    }
      this.setState({validationMessages: {}});
        createIO({
            accountId:accountId,
            paymentMethodId:data.paymentMethodId,
            amount:parseFloat(data.amount),
            note: data.note,
            documents: isInvoiceSelected ? documents : []
          })
          .then(() => this.props.loadIOSForAgency(this.props.accountId))
          .then(() => {
            this.handleSuccess()
            this.setState({isSubmitting: false})
          })
          .catch((err) => {
            this.handleError(err)
            this.setState({isSubmitting: false})
          })
  }

  handleFileUploadChange(e){
    const file = e.target.files[0]
    uploadFile('documents/IOs', file)
        .then((res) => {
          if (res) {
            let document = {fileName: file.name, url: res}
            this.setState({ documents: [...this.state.documents, document] });
          }
        })
  }

  handleDocumentDelete(document){
    this.setState({documents: this.state.documents.filter(u => u.url !== document.url)})
  }

  handleSuccess(){
    const { history, accountId, redirectURL  } = this.props;

    if(redirectURL){
      history.push(redirectURL);
    } else {
      history.push(`/superadmin/accounts/${accountId}/billing`);
    }
  }

  handleError(err){}

  render(){
    const {redirectURL,accountId,paymentMethods, isCreate} = this.props;
    const {validationMessages, isInvoiceSelected, documents } = this.state;
    const defaultPaymentMethod = paymentMethods.find((p) => p.id === this.state.paymentMethodId)

    return (
      <div className='AccountNewIO'>
        <Row>
          <Col xs='12' md='6'>
            <br />
            <h3>New IO</h3>
            <br />
            <Form onSubmit={(data) => this.handleSubmit(data)}>
              <MoneyInput label='Amount'
                          name='amount'
                          defaultValue={this.state.amount}
                          disabled={!isCreate}
                          warning={validationMessages['amount']} />
              <FormGroup>
                <Label>Payment Method</Label>
                <Input type='select'
                       name='paymentMethodId'
                       defaultValue={defaultPaymentMethod ? defaultPaymentMethod.id : undefined}
                       disabled={!isCreate}
                       onChange={(e) => {
                         this.setState({ isInvoiceSelected: paymentMethods.filter((p) => p.id === e.target.value).map((p) => p.kind).indexOf('invoice') !== -1})
                       }}>
                  {paymentMethods.filter((p) => p.kind !== 'card').map((p) => (
                    <option key={p.id} value={p.id}>
                      {formatPaymentMethod(p)}
                    </option>
                  ))}
                </Input>
              </FormGroup>
              {(isInvoiceSelected || !isCreate) &&
              <FormGroup row>
                <Label for="documents" sm={4}>Documents</Label>
                <Col sm={8}>
                  <Label for="document_upload" className="btn">Upload IO (optional)</Label>
                  <Input type="file" name="file" id="document_upload" accept='*' onChange={(e) => this.handleFileUploadChange(e)} style={{display: 'none'}}/>
                  <Row><Col sm={12}><FormText>Upload IO document, any format accepted.</FormText></Col></Row>
                </Col>
                <Col sm={{size:8, offset: 4}}>
                  <Row id="documents">
                    {documents.map((document) => (
                        <Col xs="auto" key={document.url}>
                          <span> <a href={document.url} target='_blank'>{document.fileName}</a> </span>
                          <button type="button" className="close" aria-label="Close" onClick={() => this.handleDocumentDelete(document)} >
                            <span aria-hidden="true">&times;</span>
                          </button>
                        </Col>
                    ))}
                  </Row>
                </Col>
              </FormGroup>}
              <TextInput label='Notes'
                         name='note'
                         defaultValue={this.state.note}
                         warning={validationMessages['note']}/>
              <Button isSubmit
                      disabled={this.state.isSubmitting}>{isCreate ? 'Create IO' : 'Update IO'}</Button>
              <Button
                linkHref={redirectURL ? redirectURL : `/superadmin/accounts/${accountId}/billing`}
                className='float-right'
                textColor='#666666'
                borderColor='#cccccc'
                backgroundColor='#ededed'
              >
                Cancel
              </Button>
            </Form>
          </Col>
        </Row>
      </div>
    );
  }
}

AccountNewIO.propTypes = {
  //TODO: Fill in prop types for AccountNewIO
};

AccountNewIO.defaultProps = {
  //TODO: Fill in defaultProps for AccountNewIO
};

export default AccountNewIO;



// WEBPACK FOOTER //
// ./src/routes/AccountNewIO/components/AccountNewIO.js